import React from 'react';
import PropTypes from 'prop-types';

const Delete = ({ theme, fill, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.48633 13.2669C3.48633 13.6665 3.64507 14.0497 3.92762 14.3323C4.21018 14.6148 4.5934 14.7736 4.99299 14.7736H10.993C11.3926 14.7736 11.7758 14.6148 12.0584 14.3323C12.3409 14.0497 12.4997 13.6665 12.4997 13.2669V4.24023H3.48633V13.2669ZM7.48633 13.2669V5.74023H8.66633V13.2669H7.48633ZM11.013 13.2669H10.033V5.74023H11.0063L11.013 13.2669ZM5.01299 5.74023H6.07966V13.2669H4.99299L5.01299 5.74023Z"
      fill={fill || theme.COLORS.danger}
    />
    <path
      d="M10.6667 1.9999L9.88006 1.22656H6.12007L5.36673 1.9999H3.48673C3.29086 2.00149 3.10317 2.07866 2.96281 2.21529C2.82245 2.35192 2.74026 2.53747 2.7334 2.73323C2.73514 2.93249 2.81507 3.12309 2.95597 3.26399C3.09687 3.40489 3.28747 3.48482 3.48673 3.48656H12.5134C12.7127 3.48482 12.9033 3.40489 13.0442 3.26399C13.1851 3.12309 13.265 2.93249 13.2667 2.73323C13.2599 2.53747 13.1777 2.35192 13.0373 2.21529C12.897 2.07866 12.7093 2.00149 12.5134 1.9999H10.6667Z"
      fill={fill || theme.COLORS.danger}
    />
  </svg>
);

Delete.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Delete;
